export default {
  "nav.spreadsheet": "CSSBuy Spreadsheet",
  "nav.categories": "Categories",
  "nav.guides": "Guides",
  "nav.reviews": "Reviews",
  "nav.shipping": "Shipping",
  "nav.qc": "QC",
  "nav.safety": "Safety",
  "nav.faq": "FAQ",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.article": "Article",
  "nav.home": "Home",
  "nav.guide": "Shopping Guide",
  "lang.en": "English",
  "lang.pt": "Portuguese",
  "lang.de": "German",
  "hero.eyebrow": "INDEPENDENT GUIDE • UPDATED • EASY TO SEARCH",
  "hero.title": "CSSBuy Spreadsheet — Find, Compare & Organize Products",
  "hero.subtitle": "Explore organized product links, categories, buying guides, QC information and shipping resources to make your CSSBuy research faster and easier.",
  "hero.cta_primary": "Explore CSSBuy Spreadsheet",
  "hero.cta_secondary": "Browse Categories",
  "hero.trust": "Independent resource • Organized information • External links clearly identified",
  "cta.main_site": "CSSBuy Spreadsheet",
  "cta.buy_now": "Buy It Now",
  "categories.title": "Explore Popular Categories",
  "categories.subtitle": "Find the products you want to research quickly",
  "what.title": "What is a CSSBuy Spreadsheet?",
  "what.description": "A CSSBuy Spreadsheet is a practical way to organize products, links, and research information in one place. You can browse categories, compare information, and consult guides before making a decision.",
  "what.warning": "Prices, availability, sellers, links, and shipping information may change. Always confirm current data before buying.",
  "what.cta": "Explore the Spreadsheet",
  "how.title": "How to Use CSSBuy Spreadsheet",
  "how.step1_title": "Choose a Category",
  "how.step1_desc": "Find the product type you want to research.",
  "how.step2_title": "Compare Information",
  "how.step2_desc": "Check links, prices, sizes, QC, seller, and availability.",
  "how.step3_title": "Do Your Verification",
  "how.step3_desc": "Confirm current data before buying.",
  "how.cta": "Start My Research",
  "qc.title": "Understand QC Before Buying",
  "qc.description": "QC photos and information can help identify visible details of a product, but they do not represent a guarantee of authenticity or final quality.",
  "qc.cta": "Read QC Guide",
  "shipping.title": "Understand Shipping Costs",
  "shipping.description": "The final cost may depend on weight, volume, destination, carrier, and chosen method. Always check current information.",
  "shipping.cta": "View CSSBuy Shipping Cost Guide",
  "safety.title": "Research with More Safety",
  "safety.item1": "Verify link destinations",
  "safety.item2": "Check current prices",
  "safety.item3": "Confirm sizes",
  "safety.item4": "Analyze QC",
  "safety.item5": "Verify the seller",
  "safety.item6": "Never share passwords",
  "safety.item7": "Do not send payments to unofficial contacts",
  "safety.item8": "Confirm shipping information",
  "safety.cta": "Open Safety Guide",
  "final.title": "Ready to Start Your Research?",
  "final.description": "Use CSSBuy Spreadsheet as a starting point, explore our guides, and check current information before making your decision.",
  "final.cta_primary": "Explore CSSBuy Spreadsheet",
  "final.cta_secondary": "Visit Main Website",
  "articles.title": "Latest Guides & Articles",
  "articles.read_more": "Read More",
  "articles.read_time": "min read",
  "footer.disclaimer": "cssbuybr.skin is an independent informational website and is not the official CSSBuy website.",
  "footer.resources": "CSSBuy Spreadsheet",
  "footer.company": "Company",
  "footer.languages": "Languages",
  "footer.spreadsheet": "Spreadsheet",
  "footer.categories": "Categories",
  "footer.guides": "Guides",
  "footer.reviews": "Reviews",
  "footer.shipping": "Shipping",
  "footer.qc": "QC",
  "footer.safety": "Safety",
  "footer.faq": "FAQ",
  "footer.about": "About",
  "footer.contact": "Contact",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.affiliate": "Affiliate Disclosure",
  "dropdown.label": "All Categories",
  "dropdown.placeholder": "Select a category...",
  "breadcrumbs.home": "Home",
  "article.author": "By",
  "article.updated": "Updated",
  "article.published": "Published",
  "article.read_time": "min read",
  "article.table_of_contents": "Table of Contents",
  "article.back_to_home": "Back to Home",
  "article.related_articles": "Related Articles",
  "article.share": "Share",
  "nav.products": "Products",
  "products.page_title": "CSSBuy Product Directory",
  "products.page_subtitle": "Browse all products from the CSSBuy Spreadsheet. Click any item to view and purchase on the main site.",
  "products.search_placeholder": "Search products...",
  "products.results_count": "products found",
  "products.browse_full_category": "Browse full category on main site",
  "products.no_results": "No products found. Try a different search.",
  "products.clear_filters": "Clear all filters",
  "products.cta_title": "Want more products?",
  "products.cta_desc": "Browse the full CSSBuy Spreadsheet with thousands of products, QC photos, and updated links."
};